import axios from 'axios';

const KEY = 'AIzaSyDdMcgKU3wc4FeqOYBL54eGJ7UZwmH999I';

export default axios.create({
    baseURL: 'https://www.googleapis.com/youtube/v3',
    params: {
        part: 'snippet',
        type: 'video',
        maxResults: 5,
        key: KEY,
    },
});
